<template>
  <div class="fullscreen-layout">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// Intentionally minimal for full-screen views
</script>


